define('services/events/layout-menu-events',[
    // libs
    'underscore', 'utils',
    // parent
    'src/event-aggregator'
], function(_, U, EventAggregator) {

    var LayoutMenuEvents = _.extend({}, EventAggregator.prototype, {
        tabChange: function(tabId) {
            this.trigger('tab:change', tabId);
        },
        itemClick: function() {
            this.trigger('item:click');
        }
    });
    return LayoutMenuEvents;
});

